import React from 'react';

import { connect } from 'react-redux';
import classnames from 'classnames';
import validate from "validate.js";

import './reset_password_component.scss';
import { resetPassword } from '../../../../gateway/api';
import { passwordEqualityConstraints, resetPasswordConstraints } from "../../../../util/validation_constraints";
import { showCloseButtonClass, errorClass, clearInputContent } from '../../../../util/form_login_utils';
import ErrorMessageComponent from '../get_error_message';

const ResetPasswordComponent = ({loginObj, handleChange, onButtonClick, passwordReset, errors, clearInput, apiErrors}) => {
  return(
    <div className="reset-password-component">
      {resetPasswordBeforeState(passwordReset, loginObj, handleChange, onButtonClick, errors, clearInput, apiErrors)}
      {resetPasswordAfterState(passwordReset, onButtonClick, loginObj)}
    </div>
  )
}

const resetPasswordBeforeState = (passwordReset, loginObj, handleChange, onButtonClick, errors, clearInput, apiErrors) => {
  if(!passwordReset) {
    return(
      <div>
        {inputField(loginObj, handleChange, errors, clearInput, apiErrors)}
        {showButtonComponent({'name': 'Reset'}, onButtonClick, loginObj)}
      </div>
    )
  }
}

const resetPasswordAfterState = (passwordReset, onButtonClick, loginObj) => {
  if(passwordReset) {
    return(
      <div>
        <div className="reset-success">
          Password reset successful.
        </div>
        {showButtonComponent({'name': 'Login'}, onButtonClick, loginObj)}
      </div>
    )
  }
}

const inputField = (loginObj={}, handleChange, errors, clearInput, apiErrors) => {
  const passwordFields = [{label: "password", name: "New password"}, {label: "confirmPassword", name: "Re-enter new password"}]
  return passwordFields.map((passwordField, index) => {
    return (
      <div key={index} className="input-field-container" id="input-field-container">
       <label htmlFor="textInput" className="input-label">{passwordField.name}</label>
         <div className="field">
          <input type="password"
                 className={`input-field-box ${errorClass(errors, passwordField.label)} ${passwordField.label}`}
                 value={loginObj[passwordField.label]}
                 name={passwordField.label}
                 onChange={(e) => handleChange(e, loginObj, errors, apiErrors)}></input>
          <span className={`input-close-button ${showCloseButtonClass(loginObj[passwordField.label])}`}
                onClick={(e) => clearInput(e, passwordField.label, loginObj, errors)}></span>
        </div>
        <ErrorMessageComponent inputField={passwordField.label}/>
      </div>
    )
  })
}

const showButtonComponent = (opts, onButtonClick, loginObj) => {
  return(
    <div className={`metype-button-container`}>
      <button type="submit" className="metype-button"  onClick={(e) => onButtonClick(e, loginObj, opts)}>
        {opts.name}
      </button>
    </div>
  )
}

const mapStateToProps = ({formLoginReducers}) => {
  return {
    loginObj: formLoginReducers.loginObj,
    passwordReset: formLoginReducers.passwordReset,
    errors: formLoginReducers.errors,
    apiErrors: formLoginReducers.apiErrors
  }
}

const postResetPasswordCall = (response, loginObj, dispatch) => {
  if(response.password_updated) {
    const passwordValidationResponse = validate(loginObj, resetPasswordConstraints(), { fullMessages: false });
    dispatch({ type: 'ERRORS', ...passwordValidationResponse});
    dispatch({type: 'SCREEN', screen: 'resetPassword', passwordReset: true});
  }
}

const canResetPassword = (passwordValidityResponse, loginObj, dispatch) => {
  if(Object.keys(passwordValidityResponse).length === 0) {
    resetPassword( { email: loginObj.email, otp: loginObj.otp, password: loginObj.password, password_confirmation: loginObj.confirmPassword }).then((response) => {
      postResetPasswordCall(response, loginObj, dispatch);
    })
  }
}

const validateResetPasswordForm = (validateResponse, loginObj, dispatch) => {
  if(Object.keys(validateResponse).length === 0) {
    const passwordValidityResponse  = validate({password: loginObj.password, confirmPassword: loginObj.confirmPassword}, passwordEqualityConstraints(), { fullMessages: false }) || {};
    dispatch({ type: 'ERRORS' , ...passwordValidityResponse});
    canResetPassword(passwordValidityResponse, loginObj, dispatch);
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    clearInput: (e, passwordField, loginObj, errors) => {
      clearInputContent(e, passwordField, loginObj, errors, dispatch);
    },
    handleChange: (e, loginObj, errors, apiErrors) => {
      dispatch({ type: 'LOGIN', ...loginObj, [e.target.name]: e.target.value});
      if(e.target.value.length === 0 && ((errors[e.target.name] && errors[e.target.name].length > 0))) {
        dispatch({ type: 'ERRORS', ...errors, [e.target.name]: ""});
      }
      if(e.target.value.length === 0 && Object.keys(apiErrors).length > 0) {
        dispatch({type: 'API_ERRORS', apiErrors: {}});
      }
    },
    onButtonClick: (e, loginObj, opts) => {
      e.preventDefault();
      e.stopPropagation();
      if(opts.name === "Login") {
        dispatch({type: 'SCREEN', screen: 'signin'});
        dispatch({type: 'LOGIN', ...loginObj, password: ''});
      } else {
        const validateResponse = validate(loginObj, resetPasswordConstraints(), { fullMessages: false }) || {};
        dispatch({ type: 'ERRORS', ...validateResponse });
        validateResetPasswordForm(validateResponse, loginObj, dispatch);
      }
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordComponent);



// WEBPACK FOOTER //
// ./app/javascript/pages/page/form_login_modal/reset_password_component/reset_password_component.js